/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_NoneInputs */

const en_us2_exercise_sheet_none = /** @type {(inputs: Exercise_Sheet_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

const pt_br2_exercise_sheet_none = /** @type {(inputs: Exercise_Sheet_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

const es_419_exercise_sheet_none = /** @type {(inputs: Exercise_Sheet_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

const pt_pt2_exercise_sheet_none = /** @type {(inputs: Exercise_Sheet_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

const fr_fr2_exercise_sheet_none = /** @type {(inputs: Exercise_Sheet_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

const de_de2_exercise_sheet_none = /** @type {(inputs: Exercise_Sheet_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

const it_it2_exercise_sheet_none = /** @type {(inputs: Exercise_Sheet_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

/**
* | output |
* | --- |
* | "—" |
*
* @param {Exercise_Sheet_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_none = /** @type {((inputs?: Exercise_Sheet_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_none(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_none(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_none(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_none(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_none(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_none(inputs)
	return en_us2_exercise_sheet_none(inputs)
});
export { exercise_sheet_none as "exercise-sheet.none" }